export default "__VITE_ASSET__CK3GFd64__"